import Constant from '@/const';
import axios from 'axios';

const getCheckGoods = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/goods/checkstock/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getCheckGoods;
